import { IAgreementUser } from "src/app/modules/logged/agreements/store/types";
import { ITokens } from './types';

export class Populate {
    static readonly type = '[authorization] fetch user';
    constructor() { }
}

export class Login {
    static readonly type = '[authorization] login';
    constructor(public form: any) { }
}

export class SetSession {
    static readonly type = '[authorization] set session';
    constructor(public auth: ITokens) { }
}

export class UnsetSession {
    static readonly type = '[authorization] unset session';
    constructor() { }
}

export class ChangePassword {
    static readonly type = '[authorization] change password';
    constructor(public form: any) { }
}

export class SetAgreement {
    static readonly type = '[authorization] set agreement';
    constructor(public agreement: IAgreementUser) { }
}

export class Logout {
    static readonly type = '[authorization] logout';
    constructor() { }
}
